import { render, staticRenderFns } from "./agricultural_drug.vue?vue&type=template&id=e90ee142&"
import script from "./agricultural_drug.vue?vue&type=script&lang=js&"
export * from "./agricultural_drug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports